import image1 from '../../assets/workImages/work20.jpg'
import image2 from '../../assets/workImages/work21.jpg'
import image3 from '../../assets/workImages/work13.jpg'
import image4 from '../../assets/workImages/work17.jpg'
import image5 from '../../assets/workImages/work18.jpg'
import image6 from '../../assets/workImages/work15.jpg'
import image7 from '../../assets/workImages/work12.jpg'
import image8 from '../../assets/workImages/work11.jpg'
import image9 from '../../assets/workImages/work22.jpg'
import image20 from '../../assets/workImages/work16.jpg'
import image10 from '../../assets/workImages/work39.jpg'
import image11 from '../../assets/workImages/work38.jpg'
import image12 from '../../assets/workImages/work37.jpg'
import image13 from '../../assets/workImages/work36.jpg'
import image14 from '../../assets/workImages/work35.jpg'
import image15 from '../../assets/workImages/work34.jpg'
import image16 from '../../assets/workImages/work33.jpg'
import image17 from '../../assets/workImages/work32.jpg'
import image18 from '../../assets/workImages/work31.jpg'
import image19 from '../../assets/workImages/work30.jpg'


export const MockImages = [
  {
    img: image9,
    companyName: "WebX",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image1,
    companyName: "Dangiz",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image2,
    companyName: "Eooye",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image3,
    companyName: "Sherpa Nirman Sewa",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image4,
    companyName: "AppleRugs",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image5,
    companyName: "Codeshala",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image6,
    companyName: "Bajrapani Constructions",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image7,
    companyName: "Gems Accounting and HR Management",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: image8,
    companyName: "All Seller Import Export",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image20,
    companyName: "Habre",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image10,
    companyName: "Himalayan Textile Industries",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image11,
    companyName: "Wishmandu",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image12,
    companyName: "Designer of The Year",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image13,
    companyName: "Tansen Holidays",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image14,
    companyName: "Shyam's",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image15,
    companyName: "KachoMaha",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image16,
    companyName: "MeroKishan",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image17,
    companyName: "YakBuck Coffee",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image18,
    companyName: "Thousand Miles",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
  {
    img: image19,
    companyName: "BeeSoul",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const MockImages2 = [
  {
    img: "img5.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img6.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img7.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img8.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img9.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img10.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img11.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img12.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img13.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img14.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img15.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img16.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img17.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img4.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img3.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img2.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img9.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img10.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img11.jpg",
    companyName: "Honey Bee PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },

  {
    img: "img12.jpg",
    companyName: "Honey Be PVT LTD",
    companyAddress: "Basundhara, Kathmandu, Nepal",
    email: "honeybee11@gmail.com",
    contact: "+977 9865652528",
  },
];

export const MockImages3 = [
  { img: "logo_img1.jpg" },
  { img: "logo_img2.jpg" },
  { img: "logo_img3.jpg" },
  { img: "logo_img4.jpg" },
  { img: "logo_img5.jpg" },
  { img: "logo_img6.jpg" },
  { img: "logo_img7.jpg" },
  { img: "logo_img8.jpg" },
  { img: "logo_img9.jpg" },
  { img: "logo_img10.jpg" },
  { img: "logo_img11.jpg" },
  { img: "logo_img12.jpg" },
];
